import React from 'react';
import { formatedDuration } from '../../lib/datetime';

interface FormattedDurationProps {
    timeInSeconds: number;
    className?: string;
}

const FormattedDuration: React.FC<FormattedDurationProps> = ({ timeInSeconds, className }) => {
    return <span className={className}>{formatedDuration(timeInSeconds).toLowerCase()}</span>;
};

export default FormattedDuration;
